function WinnersController() {

	this.currentNavPage = 1;
	this.pages = 1;
	this.perpage = 0;
	this.numberYears = 0;
	this.yearWidth = 0;

	this.setupYearNav();

	if( this.pages > 1 )
		this.setCurrentYearNav();

	$('.yearNav .arrow').on('click', $.proxy( this.handleYearNavClick, this ) );

	$(window).resize( $.proxy( this.handleResize, this ) );
	$(window).on('mediaQueryChange', $.proxy( this.handleMediaQueryChange, this ) );

}


WinnersController.prototype = {

	handleResize: function() {

		this.setupYearNav();

	},

	handleYearNavClick: function(e) {

		if( !$(e.currentTarget).hasClass('disabled') ) {
			if( $(e.currentTarget).hasClass('nextArrow') ) {
				this.handleYearNextPage(e);
			} else {
				this.handleYearBackPage(e);
			}
		}

	},

	handleYearNextPage: function(e,page) {
		var duration = 300;

		if( typeof page !== undefined && page >= 1 && page <= this.pages ) {
			this.currentNavPage = page;
			duration = 0;
		} else {
			this.currentNavPage++;
		}

		var index = this.currentNavPage * this.perpage;
		var tiles = this.perpage;
		var offset = 0;

		if( index > this.numberYears ) {
			tiles = this.perpage - (index - this.numberYears);
			offset = ((this.currentNavPage-2) * ((this.yearWidth*this.perpage))) + (tiles * this.yearWidth);
		} else {
			offset = (this.currentNavPage-1) * ((this.yearWidth*this.perpage));
		}

		$('.years').animate({'left':-offset},duration);

		this.setupYearNavButtons();

	},

	handleYearBackPage: function(e) {

		this.currentNavPage--;
		var tiles = this.perpage;
		var offset = (this.currentNavPage-1) * ((this.yearWidth*this.perpage));

		$('.years').animate({'left':-offset},300);

		this.setupYearNavButtons();

	},

	setupYearNav: function() {

		this.numberYears = $('.years div').length;
		this.yearWidth = $('.years div').width()+1;
		var yearsWidth = (this.numberYears*this.yearWidth)+this.numberYears;
		var containerWidth = $('.yearNav .yearsContainer').width();

		if( yearsWidth < containerWidth ) {
			$('.years').css('margin','auto');
		}

		this.perpage = Math.round(containerWidth / this.yearWidth);
		console.log(this.perpage, containerWidth, this.yearWidth );

		$('.years').width(yearsWidth);

		if( yearsWidth > containerWidth ) {
			this.pages  = Math.ceil( yearsWidth / containerWidth );
		}

		this.setupYearNavButtons();

	},

	setupYearNavButtons: function() {

		$('.yearNav .arrow').removeClass('disabled');

		if( this.pages == 1 ) {
			$('.yearNav .arrow').addClass('disabled');
		} else if( this.currentNavPage == 1 ) {
			$('.yearNav .backArrow').addClass('disabled');
		} else if( this.currentNavPage == this.pages ) {
			$('.yearNav .nextArrow').addClass('disabled');
		}
	},

	setCurrentYearNav: function() {

		var start_year = $('.years').data('start');
		var current_year = $('.years').data('current');

		var index = current_year - start_year+1;

		var onpage = Math.ceil(index / this.perpage);

		console.log('ON PAGE', onpage, index, this.perpage);

		this.handleYearNextPage(null,onpage);


	},


	handleMediaQueryChange: function(e,width) {

		if( width < 640 ) {
			this.setupYearNav();

			if( this.pages > 1 )
				this.setCurrentYearNav();

		}

		if( width >= 640 ) { // TABS & DESKTOP
			this.setupYearNav();

			if( this.pages > 1 )
				this.setCurrentYearNav();

		}
	}


};

module.exports = WinnersController;



// WEBPACK FOOTER //
// ./js/src/WinnersController.js